import { GridColDef } from "@mui/x-data-grid";
import { formatValueForStringArrayToString, getFormattedCreateDate} from "../../../utils/helper";
export const columns: GridColDef[] = [
  {
    field: "idn",
    headerName: "SNo",
    flex: 1,
    minWidth: 70,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "audit_id",
    headerName: "Audit Record Id",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "ts_id",
    headerName: "Record ID",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "user_id",
    headerName: "User ID",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "user_email_id",
    headerName: "Email Id",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "user_role",
    headerName: "User Role",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "text",
    headerName: "Text Content (Original)",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "date_time_of_entry",
    headerName: "Extracted Date",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? getFormattedCreateDate(params.value):"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "action",
    headerName: "Type of Action",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "sample_id",
    headerName: "Sample ID",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "version_id",
    headerName: "Record Version",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "created_dt",
    headerName: "Created Date",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? getFormattedCreateDate(params.value):"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "evaluation",
    headerName: "Evaluation",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  // {
  //   field: "evaluation_id",
  //   headerName: "Evaluation Id",
  //   flex: 1,
  //   minWidth: 180,
  //   renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
  //   headerAlign: "center",
  //   align: "center",
  //   headerClassName: "super-app-theme--header",
  // },
  {
    field: "corrective_action_details",
    headerName: "Corrective action details",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "review_type",
    headerName: "Review Type",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? formatValueForStringArrayToString(params.value):"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "notification_status",
    headerName: "Notification Status",
    flex: 1,
    minWidth: 180,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "notification_timestamp",
    headerName: "Notification Timestamp",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "notification_recipient",
    headerName: "Notification Recipient(s)",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "country",
    headerName: "Country",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "region",
    headerName: "Region",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? formatValueForStringArrayToString(params.value):null}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  },
  {
    field: "evaluated_risk",
    headerName: "Evaluated Risk",
    flex: 1,
    minWidth: 180,
    renderCell: (params) => <span>{params.value ? params.value:"None"}</span>,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",
  }
];
